import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

export const addEditExOpInvoiceSlice = createSlice({
    name: 'addEditExOpInvoice',
    initialState: {
        showModal: false,
        title: 'New Invoice',
        client: null,
        todayDate: moment().format('YYYY-MM-DD'),
        invd: [],
        editMode: false,
    },
    reducers: {
        toggleInvoiceModal: (state, action) => {
            state.showModal = !state.showModal
            state.title = (action.payload && action.payload.title) ? action.payload.title : 'New Invoice'
            state.todayDate = (action.payload && action.payload.todayDate) ? action.payload.todayDate : moment().format('YYYY-MM-DD')
            state.client = (action.payload && action.payload.client) ? action.payload.client : null
            state.invd = (action.payload && action.payload.invd) ? action.payload.invd : []
            state.editMode = (action.payload && action.payload.editMode) ? action.payload.editMode : false
        },
        updateClient: (state, action) => {
            state.client = (action.payload) ? action.payload : null
        }
    },
});

export const { toggleInvoiceModal, updateClient } = addEditExOpInvoiceSlice.actions;
export default addEditExOpInvoiceSlice.reducer;
